import {
  DeleteOutlined,
  EditOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Table,
  Typography,
} from 'antd';
import { debounce } from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import IntlMessages from '../../components/IntlMessage';
import PageTitle from '../../components/PageTitle';
import setiingApi from '../../api/settings';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};
const Settings = () => {
  const [form] = Form.useForm();
  const [settings, setSttings] = useState([]);
  const [reload, setReload] = useState(true);
  const [loading, setLoading] = useState(false);
  const intl = useIntl();
  useEffect(() => {
    async function fetchData() {
      let items = await setiingApi.getAll();
      setSttings(items);
    }
    fetchData();
  }, [reload]);
  const onFinish = (values) => {
    const signList = values['sights'];
    // const obj = JSON.parse(values);
    const newData = Object.keys(values)
      .filter((key) => key.startsWith('key'))
      .map((key) => {
        console.log(key);
        const id = key.slice(3);
        return {
          key: values[key],
          value: values['value' + id],
        };
      });
    if (signList) {
      const newSignList = signList.map((signDict) => {
        return { key: signDict['key'], value: signDict['value'] };
      });
      newData.push(...newSignList);
    }

    setLoading(true);
    setiingApi
      .create(newData)
      .then(() => {
        setLoading(false);
        setReload(!reload);
        form.setFieldsValue({
          sights: [],
        });
      })
      .catch((error) => {
        console.error(error);
        Modal.error({
          title: error.data.message,
          okText: intl.formatMessage({ id: 'global.close' }),
        });
        setLoading(false);
      });
  };
  const handleChange = () => {
    form.setFieldsValue({
      sights: [],
    });
  };

  const onRemove = (data) => {
    Modal.confirm({
      title: intl.formatMessage({ id: 'global.delete_confirm' }),
      okText: intl.formatMessage({ id: 'global.yes' }),
      onOk: async () => {
        await setiingApi.delete(data.id).catch((error) => {
          console.error(error);
          Modal.error({
            title: error.data.message,
            okText: intl.formatMessage({ id: 'global.close' }),
          });
          setLoading(true);
        });
        setLoading(false);
        setReload(!reload);
      },
      onCancel() {},
    });
  };
  return (
    <Card bordered={false} style={{ minHeight: '100%' }}>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Row justify="space-between">
          <Col>
            <PageTitle title={<IntlMessages id="global.settings" />} />
          </Col>
        </Row>
        <Form form={form} onFinish={onFinish} autoComplete="off">
          <Row gutter={16} style={{ marginBottom: '5px' }}>
            <Col span={1} className="setting_label"></Col>
            <Col span={6} className="setting_label">
              <IntlMessages id="global.key" />
            </Col>
            <Col span={16} className="setting_label">
              <IntlMessages id="global.value" />
            </Col>
            <Col span={1} className="setting_label"></Col>
          </Row>
          {settings.length > 0 &&
            settings.map((item) => (
              <Input.Group key={item.id}>
                <Row gutter={16}>
                  <Col span={1}>{<IntlMessages id="global.label" />}</Col>
                  <Col span={6}>
                    <Form.Item name={`key${item.id}`} initialValue={item.key}>
                      <Input readOnly />
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item
                      name={`value${item.id}`}
                      initialValue={item.value}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Form.Item name={`id${item.id}`} initialValue={item.id}>
                    <Input hidden style={{ display: 'none' }} />
                  </Form.Item>
                  <Col span={1}>
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => onRemove(item)}
                      danger
                      shape="round"
                      icon={<DeleteOutlined />}></Button>
                  </Col>
                </Row>
              </Input.Group>
            ))}
          <Form.List name="sights">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field) => (
                  <Row gutter={16} key={field.key} align="baseline">
                    <Col span={1}>{<IntlMessages id="global.label" />}</Col>
                    <Form.Item
                      noStyle
                      shouldUpdate={(prevValues, curValues) =>
                        prevValues.area !== curValues.area ||
                        prevValues.sights !== curValues.sights
                      }>
                      {() => (
                        <Col span={6}>
                          <Form.Item
                            {...field}
                            name={[field.name, 'key']}
                            rules={[
                              {
                                required: true,
                                message: (
                                  <IntlMessages id="global.requiredfield" />
                                ),
                              },
                            ]}>
                            <Input />
                          </Form.Item>
                        </Col>
                      )}
                    </Form.Item>
                    <Col span={16}>
                      <Form.Item
                        {...field}
                        name={[field.name, 'value']}
                        rules={[
                          {
                            required: true,
                            message: <IntlMessages id="global.requiredfield" />,
                          },
                        ]}>
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={1}>
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => remove(field.name)}
                        danger
                        shape="round"
                        icon={<DeleteOutlined />}></Button>
                    </Col>
                  </Row>
                ))}

                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}>
                    Add Setting
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
          <Form.Item>
            <Button
              type="primary"
              className="login-form-button"
              htmlType="submit"
              loading={loading}>
              <IntlMessages id="global.save" />
            </Button>
          </Form.Item>
        </Form>
      </Space>
    </Card>
  );
};

export default Settings;
